import { render } from "./mvt-mortgage.vue?vue&type=template&id=67eded04"
import script from "./mvt-mortgage.js?vue&type=script&lang=js"
export * from "./mvt-mortgage.js?vue&type=script&lang=js"

import "./mvt-mortgage.vue?vue&type=style&index=0&id=67eded04&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__